import { ValidationError } from "@common/types";
import { EmailSnippetReadModel } from "@Alternatives/Alternatives/Domain/readmodels";

export class EmailSenderViewModel
{
    opened: boolean = false;
    sending: boolean = false;

    alternativeId: string | null = null;
    alternativeName: string | null = null;

    defaultTo: string | null = null;
    defaultReplyTo: string | null = null;

    emailSnippets: EmailSnippetReadModel[] = [];

    errors: ValidationError[] = [];

    show(alternativeId: string, alternativeName: string, defaultTo: string | null, defaultReplyTo: string | null, emailSnippets: EmailSnippetReadModel[])
    {
        this.alternativeId = alternativeId;
        this.alternativeName = alternativeName;
        this.defaultTo = defaultTo;
        this.defaultReplyTo = defaultReplyTo;
        this.emailSnippets = emailSnippets;

        this.sending = false;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.alternativeId = null;
        this.alternativeName = null;
        this.defaultTo = null;
        this.defaultReplyTo = null;
        this.emailSnippets = [];

        this.sending = false;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.sending = false;
        this.errors = errors;
    }

    clearEmailValidationErrors()
    {
        this.errors = [];
    }
}

export class EmailSenderFormSubmitEventPayload
{
    alternativeId: string;
    subject: string;
    replyToEmail: string;
    to: string[];
    bodyHtml: string;

    constructor(alternativeId: string, subject: string, replyToEmail: string, to: string[], bodyHtml: string)
    {
        this.alternativeId = alternativeId;
        this.subject = subject;
        this.replyToEmail = replyToEmail;
        this.to = to;
        this.bodyHtml = bodyHtml;
    }
}